export default "__VITE_ASSET__Bx8J1dfG__"